export enum FilterType {
  NONE = "NONE",
  EMAIL = "EMAIL",
  USER_NAME = "USER_NAME",
  ACCOUNT_ID_OR_TAX_NUMBER = "ACCOUNT_ID_OR_TAX_NUMBER",
}
